const preferences = {
  preferenceSettings: {
    nameAlreadyExist: '¡Nombre repetido!',
    nameIsEmpty: '¡El nombre está vacío!',
    notificationPreference: 'Seleccionar los sitios y la configuración de preferencias de notificación correspondiente',
    option1: 'Quiero recibir notificaciones recomendadas de Enphase para todos los sitios.',
    option2: 'Quiero personalizar mis notificaciones',
    pageHeader: 'Preferencias',
    title: 'Seleccionar una opción para Notificaciones',
    saveDialogHeader: '¿Guardar cambios?',
    saveConfirmText: '¿Quiere guardar los cambios que ha realizado?',
    cancelButton: 'Descartar',
    saveButton: 'Guardar',
    defaultDeselectWarning: 'Nota: No puede eliminar sitios del conjunto de preferencias predeterminado',
    displayPreferences: 'Preferencias de visualización',
    ownSites: 'Sitios Propios',
    otherSites: 'Otros sitios',
    emptySites: '¡No hay sitios disponibles!',
    emptyPreferenceSet: '¡Sin preferencias!',
    preference: 'Preferencia',
    actions: 'Acciones',
    settingsInfo: 'Esta configuración es aplicable solo a los sitios de Ensemble',
    selectType: 'Conjuntos de preferencias',
    selectSite: 'Selección de sitio',
    selectSettings: 'Configuración de preferencias de notificación',
    addText: 'Agregar',
    deleteAlertHeader: 'Confirmar eliminación',
    deleteAlertDescription: '¿Está seguro de quiere eliminar esta preferencia permanentemente?',
    deleteAlertCancel: 'Cancelar',
    deleteAlertConfirm: 'Aceptar',
    siteEditWarning:
      'Por defecto, todos los sitios de su propiedad y otros sitios están configurados como "Preferencia por defecto - De propiedad" y "Preferencia por defecto - Otros" como su Preferencia de Notificación respectivamente.',
    defaultOwnInfo: 'Todos los sitios de propiedad están configurados en "Preferencia por defecto - De propiedad"',
    defaultOtherInfo: 'Todos los otros sitios están configurados como "Preferencia por defecto - Otros"',
    defaultInfo: 'Todos los sitios están configurados en "Preferencia predeterminada".',
    createNew: 'Agregar nueva preferencia',
    siteEditWarningMinimal:
      'De forma predeterminada, los sitios están configurados en "Preferencia predeterminada" como su Preferencia de notificación.',
    selectAll: 'Seleccionar todo',
    generalNotification: 'Notificaciones generales',
    switchToNewPreferencePage: 'PÁGINA PARA CAMBIAR A LAS PREFERENCIAS NUEVAS'
  },
  preferences: {
    pageHeader: 'Preferencias',
    title: 'Configuración de preferencias',
    notificationPreference: 'Preferencias de notificaciones',
    activationNotification: 'Enviarme notificaciones de activación.',
    monthlySummary: 'Enviarme resúmenes mensuales del rendimiento del sistema.',
    newsletters: 'Enviarme boletines, promociones y encuestas relacionados con los productos o servicios de Enphase.',
    newLeadsNotification: 'Notificarme de nuevos clientes potenciales y sus cambios de condición',
    alertEmail: 'PREFERENCIAS DE CORREO ELECTRÓNICO DE ALERTA',
    deviceEventsEmail:
      'Enviarme un correo electrónico sobre las incidencias de dispositivo (selecciona el nivel de impacto a continuación):',
    exceptionsAlertEmail:
      'Puedes especificar excepciones para tus preferencias de correo electrónico de alerta por sistema.',
    alertPreferences: 'Visualizar preferencias de alertas por sistema',
    saveNotificationPreferences: 'GUARDAR PREFERENCIAS DE NOTIFICACIONES',
    displayPreferences: 'Preferencias de visualización',
    displayUnits: 'Unidades de visualización',
    metric: 'Métrica',
    imperial: 'Imperial',
    saveDisplayPreferences: 'GUARDAR PREFERENCIAS DE VISUALIZACIÓN',
    systemAlert: 'Preferencias de alerta del sistema: ',
    saveChanges: 'Guardar cambios',
    label:
      'Enviarme un correo electrónico sobre las incidencias de dispositivo (selecciona el nivel de impacto a continuación):',
    alertEmailPreference: 'Preferencia de correo electrónico de alerta',
    systems: 'Sistemas'
  }
};

export default preferences;
